export default __webpack_public_path__ + "static/media/pdf_document.c373c287.svg";